<template>
    <section class="mobile-trasaction-details-section">
        <div class="trasaction-dtails-container" v-if="transactionDetails">
                <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Request Id</div>
                <div class="detailedTransaction-container-info-descr">#txn{{transactionDetails.id }}</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Date &amp; Time</div>
                <div class="detailedTransaction-container-info-descr"><span>{{ $dateTime.sportItemDate(transactionDetails.created_at, 'MMM DD, YYYY, H:mm:ss') }}</span></div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Amount</div>
                <div class="detailedTransaction-container-info-descr">₹ {{ transactionDetails.bank_amount }}</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Type</div>
                <div class="detailedTransaction-container-info-descr">{{ getRequestType(transactionDetails.request_type_id) }}</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Status</div>
                <div class="detailedTransaction-container-info-descr">{{ getTransactionStatus(transactionDetails.status) }}</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Payment Type</div>
                <div class="detailedTransaction-container-info-descr">IMPS</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">Remarks</div>
                <div class="detailedTransaction-container-info-descr" v-if="transactionDetails.request_images.length > 0">
                    <div v-for="images in transactionDetails.request_images" :key="images.id">{{ images.remarks }}</div>
                </div>
                <div class="detailedTransaction-container-info-descr" v-else>---</div>
            </div>
            <div class="detailedTransaction-container-info" v-if="transactionDetails.request_images && transactionDetails.request_images?.length">
                <div class="detailedTransaction-container-info-title">Transection Images</div>
                <div class="detailedTransaction-container-info-descr">
                    <a class="btn btn-primary ms-1 mt-1" :href="s3UrlWalletUrl + request_image.image" target="_blank" v-for="(request_image, imgKey) in transactionDetails.request_images" :key="imgKey">Transaction Image {{ imgKey + 1 }}</a>
                </div>
            </div>
        </div>
        <div class="detailedTransaction-container" v-else>
            <p>No record found</p>
        </div>
    </section>
</template>

<script>
export default {
   name: 'TransactionDetails',
   data(){
        return{
            transactionId: null,
            transactionDetails: null,
            s3UrlWalletUrl: null 
        }
   },
    mounted(){
        this.transactionId = this.$route?.params?.id
        this.getTrasactionDetails()
    },
    methods:{
        getTrasactionDetails() {
            this.$store.dispatch('setGlobalLoader', true);
            this.$apiCall('get', 'GET_TRANSACTION_DETAILS', null, 'user', { id: this.transactionId}).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response.data.error);
                    }
                    else {
                        this.transactionDetails = response?.data?.data;
                        this.s3UrlWalletUrl = response.data.s3UrlWalletUrl;
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        getRequestType(type){
            switch (type) {
                case 1 :
                    return 'Create Id';
                case 2 :
                    return 'Deposit';
                case 3 :
                    return 'Withdrawal';
                case 4 :
                    return 'Transfer Fund';
                case 5 :
                    return 'Forgot Password';
                case 6 :
                    return 'Close Id';
                case 7 :
                    return 'Id Bonus';
                case 8 :
                    return 'Referral';
                case 9 :
                    return 'Referral Debit';
            }
        },
        getTransactionStatus(status){
            switch (status) {
               case 1 :
                  return 'Pending';
               case 2 :
                  return 'Approved';
               case 3 :
                  return 'Rejected';
               case 4 :
                  return 'Canceled';
               case 5 :
                  return 'Closed';
            }
        },
    }
}
</script>